import useKayttaja from './useKayttaja';

export default function useIsOmistaja(toimisto) {
  const { kayttajaId } = useKayttaja();
  const { omistaja } = toimisto;

  return kayttajaId === omistaja;
}
